import { Nav, Tab } from "react-bootstrap"
import WorkbooksList from "./components/WorkbooksList";
import StockPricesTable from "./components/StockPricesTable";

const WorkbooksSiderbar = () => {
  return (
    <Tab.Container
      id="workbook-list-sidebar"
      defaultActiveKey="Workbooks"
      mountOnEnter
    >
      <Nav
        variant="pills"
        className="border-bottom gap-10 pb-2 justify-content-between underlineTab"
      >
        <Nav.Item className="px-2">
          <Nav.Link
            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
            eventKey="Workbooks"
          >
            Workbooks
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="px-2">
          <Nav.Link
            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
            eventKey="StockPrices"
          >
            Stock Prices
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content className="py-2">
        <Tab.Pane eventKey="Workbooks">
          <WorkbooksList />
        </Tab.Pane>
        <Tab.Pane eventKey="StockPrices">
          <StockPricesTable />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  )
}

export default WorkbooksSiderbar;